<div class="subtitle-1 overview-text">{{title}}</div>

<ul class="sections">
  <li *ngFor="let section of sections" (click)="changeActiveSection(section)">
    <a class="section"
       [class.active]="section.slug === activeSection.slug"
       routerLink="./" fragment="{{section.slug}}">{{section.title}}</a>
  </li>
</ul>
